import { useEffect } from 'react';
import { FlexContainer, Text, Spinner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { iconsPaths } from 'Constants/iconsPath';
import { routes } from 'Constants/routes';
import * as Styled from '../../styles';
import { useFetchGetPreviousYearResultPolling } from '../../hooks';

const CalculateResult = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const { data, isLoading } = useFetchGetPreviousYearResultPolling();

  useEffect(() => {
    if (data && data?.records?.length > 0) {
      history.push(routes.PREVIOUS_YEARS);
    }
  }, [data]);

  return (
    <Styled.ThreeColLayout>
      <Styled.TitleContainer type="fds_heading_bold_H4" color="dark_500">
        {t('PreviousYears.title')}
      </Styled.TitleContainer>
      <FlexContainer direction="column">
        <Styled.Title type="fds_heading_bold_H4" color="dark_500">
          {t('PreviousYears.title')}
        </Styled.Title>
        <Styled.ContainerInProgress>
          {isLoading ? (
            <FlexContainer direction="column" align="center" justify="center">
              <Spinner size="M" align="center" justify="center" />
            </FlexContainer>
          ) : (
            <FlexContainer direction="column" align="center" justify="center">
              <img src={iconsPaths.PREVIOUS_YEARS_IN_PROGRESS} alt="workInProgress" />
              <Text align="center" type="paragraphs" color="dark" size="L_XL_S" mt="fds_size_32">
                {t('PreviousYears.calculate.title')}
              </Text>
              <Styled.DescriptionContainer>
                <Text align="center" type="fds_paragraph_medium_M" color="dark_500">
                  {t('PreviousYears.calculate.description')}
                </Text>
              </Styled.DescriptionContainer>
              <Styled.Informative
                mode="light"
                hasIcon
                description={t('PreviousYears.contact.description')}
                title={t('PreviousYears.calculate.contact')}
                noClose
                helpUrl="https://help.taxdown.com.mx/es/"
                helpLabel={t('PreviousYears.Informative.helpButton')}
              />
            </FlexContainer>
          )}
        </Styled.ContainerInProgress>
      </FlexContainer>
    </Styled.ThreeColLayout>
  );
};

export default CalculateResult;
